module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Fatal-Vows-3.2854dd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Fatal-Vows-3.jpg
// module id = 4i4e
// module chunks = 0